import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const locationService = {
    getAll,
    store,
    show,
    update,
    updateStatus,
    softDelete,
    destroy,
};

const MODULE = {
    LOCATION: 'locations',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll (filter) {
    const request = {
        params: {
            page: filter?.pageNumber,
            size: filter?.pageSize,
            is_active: filter?.isActive,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.LOCATION}`, request);
}

export function store (data) {
    const request = {
        state_uuid: data.stateUUID,
        country_uuid: data.countryUUID,
        name: data.name,
        display_name: data.displayName,
        addrLine1: data.addrLine1,
        addrLine2: data.addrLine2,
        addrLine3: data.addrLine3,
        city: data.city,
        postcode: data.postcode,
        google_map_link: data.googleMapLink,
        lat: data.lat,
        lng: data.lng,
    };

    return apiHelper(API_URL).post(`/${MODULE.LOCATION}`, request);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.LOCATION}/${uuid}`);
}

export function update (data) {
    const request = {
        state_uuid: data.stateUUID,
        country_uuid: data.countryUUID,
        name: data.name,
        display_name: data.displayName,
        addrLine1: data.addrLine1,
        addrLine2: data.addrLine2,
        addrLine3: data.addrLine3,
        city: data.city,
        postcode: data.postcode,
        google_map_link: data.googleMapLink,
        lat: data.lat,
        lng: data.lng,
    };

    return apiHelper(API_URL).put(`/${MODULE.LOCATION}/${data.uuid}`, request);
}

export function updateStatus (data) {
    const request = {
        is_active: data.isActive,
    };

    return apiHelper(API_URL).patch(`/${MODULE.LOCATION}/status/${data.uuid}`, request);
}

export function softDelete (data) {
    return apiHelper(API_URL).patch(`/${MODULE.LOCATION}/delete/${data.uuid}`);
}

export function destroy (data) {
    return apiHelper(API_URL).delete(`/${MODULE.LOCATION}/${data.uuid}`);
}